import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface GlossaryItemProps {
  term: string;
  definition: string;
  businessContext: string;
  relatedTerms: string[];
  isExpanded: boolean;
  onToggle: () => void;
}

const GlossaryItem = ({ 
  term, 
  definition, 
  businessContext, 
  relatedTerms,
  isExpanded,
  onToggle 
}: GlossaryItemProps) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <button 
        onClick={onToggle}
        className="w-full px-6 py-4 flex items-center justify-between hover:bg-muted/50 transition-colors duration-300"
      >
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="BookOpenIcon" size={16} className="text-primary" />
          </div>
          <span className="font-display font-semibold text-foreground text-left">
            {term}
          </span>
        </div>
        <Icon 
          name="ChevronDownIcon" 
          size={20} 
          className={`text-muted-foreground transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
        />
      </button>
      
      {isExpanded && (
        <div className="px-6 pb-6 space-y-4">
          <div>
            <div className="text-sm font-semibold text-muted-foreground mb-2">Definition:</div>
            <p className="text-foreground">{definition}</p>
          </div>
          
          <div>
            <div className="text-sm font-semibold text-muted-foreground mb-2">Business Context:</div>
            <p className="text-foreground">{businessContext}</p>
          </div>
          
          {relatedTerms.length > 0 && (
            <div>
              <div className="text-sm font-semibold text-muted-foreground mb-2">Related Terms:</div>
              <div className="flex flex-wrap gap-2">
                {relatedTerms.map((relatedTerm, index) => (
                  <span key={index} className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full">
                    {relatedTerm}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GlossaryItem;